import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
  ChangeDetectionStrategy
} from '@angular/core';
import { SearchDisplayModel } from 'src/app/common/models/searchDisplayModel';
import { SearchService } from 'src/app/services/search.service';
import {
  SearchModel,
  MatterSearchModel,
  DocumentSearchModel,
  EmailSearchModel,
  SearchCriteriaModel,
  LibraryInfoModel,
  LookupSearchRequestModel,
} from 'src/app/common/models/searchModel';
import {
  SearchTypeEnum,
  SearchCategoryType,
  SearchPrefixType,
  ListTypeEnum,
} from 'src/app/common/enum';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import {
  RouteEventTypeEnum,
  RouteTypes,
} from 'src/app/common/enum/routeEventType';
import appConstant from 'src/assets/app-text.json';
import { SharedLeftpanelFilterService } from 'src/app/services/shared-services/shared-leftpanel-filter.service';
@Component({
    selector: 'haven-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent implements OnInit {
  
  @ViewChild('searchInput', { static: false }) searchField?: ElementRef;
  @ViewChild('auto', { static: false }) autoField?: any;
  @ViewChild('auto') auto;
  appConstant;
  searchtypes: SearchDisplayModel[] = [];
  selectedSearchModel: SearchModel = new SearchModel();
  searchCriteria: SearchCriteriaModel[];
  currentSearchCrieteria: string;
  searchLabel: string;
  searchText: string;
  searchAutoCompleteText: string;
  isPopupToBeShown = false;
  isNotSearch = false;
  isSearchSubmit = false;
  isSearch = false;
  isRouteSubscribed = false;
  isShowAutoComplete = false;
  isInvalid = false;
  autoCompleteLabel: string;
  autoCompletelabelWidth: string;
  lookupValueResult = [];
  constructor(
    private searchService: SearchService,
    private route: ActivatedRoute,
    private router: Router,
    private eRef: ElementRef,
    private sharedLeftpanelFilterService: SharedLeftpanelFilterService
  ) {}

  ngOnInit() {
    let url = this.router.url;
    this.setSearchType(url);
    this.getSearchItems();
    this.appConstant = appConstant;
    this.isSearch = this.route.snapshot.queryParams.search || false;
    this.searchService.getClearSearchRequest().subscribe(() => {
      if (this.searchText || this.searchAutoCompleteText) {
        this.clearSearchText(false);
      }
    });
    this.router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd &&
        (this.router.url === RouteTypes.DOCUMENTS ||
          this.router.url === RouteTypes.EMAILS ||
          this.router.url === RouteTypes.MATTERS)
      ) {
        // Show loading indicator
        url = event.url;
        this.setSearchType(url);
        this.clearSearchOnRoute();
        this.onSearchTypeSelected(this.selectedSearchModel.selectedSearchType);
      }
    });
  }
  onSearchFocus() {
    this.isNotSearch = false;
    this.isPopupToBeShown = true;
    if (!this.isPopupToBeShown) {
      const url = this.router.url;
      this.setSearchType(url);
    }
    this.onSearchTypeSelected(this.selectedSearchModel.selectedSearchType);
  }
  onSearchBlur() {
    this.isNotSearch = true;
    this.isPopupToBeShown = false;
    this.clearAutoComplete();
  }
  setSearchType(url) {
    if (url.indexOf(RouteEventTypeEnum.DOCUMENTS) !== -1) {
      this.selectedSearchModel.selectedSearchType = SearchTypeEnum.DOCUMENT;
    } else if (url.indexOf(RouteEventTypeEnum.EMAILS) !== -1) {
      this.selectedSearchModel.selectedSearchType = SearchTypeEnum.EMAIL;
    } else if (url.indexOf(RouteEventTypeEnum.MATTERS) !== -1) {
      this.selectedSearchModel.selectedSearchType = SearchTypeEnum.MATTER;
    } else {
      this.selectedSearchModel.selectedSearchType = SearchTypeEnum.DOCUMENT;
    }
  }
  clearSearchOnRoute() {
    if (this.router.url.indexOf('search=true') === -1) {
      this.clearSearchContent();
      this.clearSearchData();
    }
  }
  onSearchTypeSelected(searchType) {
    if (this.selectedSearchModel.selectedSearchType !== searchType) {
      this.clearSearchContent();
    }
    this.selectedSearchModel.selectedSearchType = searchType;
    this.searchCriteria = this.searchtypes.filter(
      (x) => x.displayText === searchType
    )[0].searchCriteria;
  }
  clearSearchContent() {
    this.isInvalid = false;
    this.searchText = '';
    this.searchLabel = '';
    this.selectedSearchModel.documentSearchModel = new DocumentSearchModel();
    this.selectedSearchModel.emailSearchModel = new EmailSearchModel();
    this.selectedSearchModel.matterSearchModel = new MatterSearchModel();
    this.currentSearchCrieteria = '';
    if(this.isShowAutoComplete)
    {
      this.isShowAutoComplete = false;
      this.clearAutoComplete();
    }
    setTimeout(() => { this.searchField.nativeElement.focus(); });
  }
  getSearchItems() {
    this.isSearchSubmit = false;
    this.searchText = '';
    this.searchtypes = this.searchService.getAllSearchItems();
    this.searchCriteria = this.searchtypes.filter(
      (x) => x.displayText === this.selectedSearchModel.selectedSearchType
    )[0].searchCriteria;

    this.currentSearchCrieteria = '';
  }
  onSearchCategorySelected(searchCategory: SearchCriteriaModel) {
    this.isSearchSubmit = false;
    this.clearSearchContent();
    this.currentSearchCrieteria = searchCategory.displayText;
    switch (searchCategory.displayText) {
      case SearchCategoryType.TITLE:
        this.searchText =   SearchPrefixType.TITLE;
        this.isShowAutoComplete = false;
        break;
      case SearchCategoryType.AUTHOR:
        this.searchText = this.autoCompleteLabel = SearchPrefixType.AUTHOR;
        this.autoCompletelabelWidth = '20px';
        this.isShowAutoComplete = true;
        break;
      case SearchCategoryType.NUMBER:
        this.searchText = SearchPrefixType.NUMBER;
        this.isShowAutoComplete = false;
        break;
      case SearchCategoryType.CLIENT:
        this.searchText = this.autoCompleteLabel =  SearchPrefixType.CLIENT;
        this.autoCompletelabelWidth = '45px';
        this.isShowAutoComplete = true;
        break;
      case SearchCategoryType.MATTER:
        this.searchText = this.autoCompleteLabel =  SearchPrefixType.MATTER;
        this.autoCompletelabelWidth = '50px';
        this.isShowAutoComplete = true;
        break;
      case SearchCategoryType.SUBJECT:
        this.searchText = SearchPrefixType.SUBJECT;
        this.isShowAutoComplete = false;
        break;
    }
    if (this.isShowAutoComplete) {
      this.clearAutoComplete();
      
      setTimeout(() => {
        const inputEl: HTMLInputElement | null = this.autoField?.elementRef?.nativeElement?.querySelector('input');
        if (inputEl) {
          inputEl.style.marginLeft = this.autoCompletelabelWidth;
          inputEl?.focus();
        }
      });
    }
    else {
      setTimeout(() => { this.searchField.nativeElement.focus(); });
    }
  }

  clearAutoComplete(){
    if (this.auto) {
      this.auto.clear();
      this.auto.focus();
      this.auto.close();
    }
    this.lookupValueResult = [];
  }

  clearSearchText(focusInput = true) {
    this.isInvalid = false;
    this.isSearchSubmit = true;
    this.isNotSearch = false;
    this.isShowAutoComplete = false;
    this.searchText = '';
    this.searchAutoCompleteText = '';
    this.searchService.clearSearchSubject();
    this.currentSearchCrieteria = '';
    this.selectedSearchModel.documentSearchModel = new DocumentSearchModel();
    this.selectedSearchModel.emailSearchModel = new EmailSearchModel();
    this.selectedSearchModel.matterSearchModel = new MatterSearchModel();
    if (this.isShowAutoComplete) {
      this.clearAutoComplete();
    }
    else if (focusInput) {
      setTimeout(() => { this.searchField.nativeElement.focus(); });
    }
  }
  onSearchSubmit() {
    this.isSearchSubmit = true;
    switch (this.selectedSearchModel.selectedSearchType) {
      case SearchTypeEnum.DOCUMENT:
        if (this.selectedSearchModel.documentSearchModel.searchValue === '') {
          this.isInvalid = true;
        } else {
          this.isInvalid = false;
          this.router.navigate(['dashboard/documents'], {
            queryParams: { search: true },
          });
          this.searchService.setSearchSubject({
            SearchType: SearchTypeEnum.DOCUMENT,
            data: this.selectedSearchModel.documentSearchModel,
          });
        }
        break;
      case SearchTypeEnum.EMAIL:
        if (this.selectedSearchModel.emailSearchModel.searchValue === '') {
          this.isInvalid = true;
        } else {
          this.isInvalid = false;
          this.router.navigate(['dashboard/emails'], {
            queryParams: { search: true },
          });
          this.searchService.setSearchSubject({
            SearchType: SearchTypeEnum.EMAIL,
            data: this.selectedSearchModel.emailSearchModel,
          });
        }
        break;
      case SearchTypeEnum.MATTER:
        if (this.selectedSearchModel.matterSearchModel.searchValue === '') {
          this.isInvalid = true;
        } else {
          this.isInvalid = false;
          this.router.navigate(['dashboard/matters'], {
            queryParams: { search: true },
          });
          this.searchService.setSearchSubject({
            SearchType: SearchTypeEnum.MATTER,
            data: this.selectedSearchModel.matterSearchModel,
          });
        }
        break;
      default: {
        break;
      }
    }
    this.isPopupToBeShown = false;
    if(this.isShowAutoComplete && this.auto)
    {
      this.auto.close();
      this.lookupValueResult = [];
    }
  }
  clearSearchData() {
    switch (this.selectedSearchModel.selectedSearchType) {
      case SearchTypeEnum.DOCUMENT:
        this.searchService.setSearchSubject({
          SearchType: SearchTypeEnum.DOCUMENT,
          data: this.selectedSearchModel.documentSearchModel,
        });
        break;
      case SearchTypeEnum.EMAIL:
        this.searchService.setSearchSubject({
          SearchType: SearchTypeEnum.EMAIL,
          data: this.selectedSearchModel.emailSearchModel,
        });
        break;
      case SearchTypeEnum.MATTER:
        this.searchService.setSearchSubject({
          SearchType: SearchTypeEnum.MATTER,
          data: this.selectedSearchModel.matterSearchModel,
        });
        break;
      default: {
        break;
      }
    }
  }
  isAlphaNumeric(value) {
    const isValid = /^[ A-Za-z0-9_@./#&+-{}*\(\)!$%^~\s|]*$/.test(value);
    return isValid;
  }
  isNumeric(value) {
    const isValid = /^[\d]+$/.test(value);
    return isValid;
  }
  setMatterSearchModel(autoSelectValue) {
    switch (this.currentSearchCrieteria) {
      case SearchCategoryType.TITLE:
        this.selectedSearchModel.matterSearchModel.searchCriteria = 'title';
        this.selectedSearchModel.matterSearchModel.title = this.searchText.replace(
          SearchPrefixType.TITLE,
          ''
        );
        this.selectedSearchModel.matterSearchModel.searchValue = this.searchText.replace(
          SearchPrefixType.TITLE,
          ''
        );
        break;
      case SearchCategoryType.CLIENT:
        this.selectedSearchModel.matterSearchModel.searchCriteria = 'client';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.matterSearchModel.client = autoSelectValue.alias;
          this.selectedSearchModel.matterSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.matterSearchModel.client = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
          this.selectedSearchModel.matterSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
        }
        break;
      case SearchCategoryType.MATTER:
        this.selectedSearchModel.matterSearchModel.searchCriteria = 'matter';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.matterSearchModel.matter = autoSelectValue.alias;
          this.selectedSearchModel.matterSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.matterSearchModel.matter = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
          this.selectedSearchModel.matterSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
        }
        break;
      default: {
        this.selectedSearchModel.matterSearchModel.searchCriteria = '';
        this.selectedSearchModel.matterSearchModel.searchValue = this.isAlphaNumeric(
          this.searchText
        )
          ? this.searchText
          : '';
        this.selectedSearchModel.matterSearchModel.title = this.searchText.replace(
          SearchPrefixType.TITLE,
          ''
        );
        break;
      }
    }
  }
  setEmailSearchModel(autoSelectValue) {
    switch (this.currentSearchCrieteria) {
      case SearchCategoryType.NUMBER:
        if (
          this.isNumeric(this.searchText.replace(SearchPrefixType.NUMBER, ''))
        ) {
          this.selectedSearchModel.emailSearchModel.searchCriteria =
            'number';
          this.selectedSearchModel.emailSearchModel.docNumber = parseInt(
            this.searchText.replace(SearchPrefixType.NUMBER, ''),
            10
          );
          this.selectedSearchModel.emailSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.NUMBER,
            ''
          );
        }
        break;
      case SearchCategoryType.CLIENT:
        this.selectedSearchModel.emailSearchModel.searchCriteria = 'client';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.emailSearchModel.client = autoSelectValue.alias;
          this.selectedSearchModel.emailSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.emailSearchModel.client = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
          this.selectedSearchModel.emailSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
      }
        break;
      case SearchCategoryType.MATTER:
        this.selectedSearchModel.emailSearchModel.searchCriteria = 'matter';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.emailSearchModel.matter = autoSelectValue.alias;
          this.selectedSearchModel.emailSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.emailSearchModel.matter = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
          this.selectedSearchModel.emailSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
        }
        break;
      case SearchCategoryType.SUBJECT:
        this.selectedSearchModel.emailSearchModel.searchCriteria = 'subject';
        this.selectedSearchModel.emailSearchModel.subject = this.searchText.replace(
          SearchPrefixType.SUBJECT,
          ''
        ).trim();
        this.selectedSearchModel.emailSearchModel.searchValue = this.searchText
          .replace(SearchPrefixType.SUBJECT, '')
          .trim();
        break;
      default: {
        this.selectedSearchModel.emailSearchModel.searchCriteria = '';
        this.selectedSearchModel.emailSearchModel.searchValue = this.isAlphaNumeric(
          this.searchText
        )
          ? this.searchText
          : '';
        if ( this.isAlphaNumeric(this.searchText) && !this.isNumeric(this.searchText)) {
          this.selectedSearchModel.emailSearchModel.subject = this.searchText.replace(
            SearchPrefixType.SUBJECT,
            ''
          );
        } else if (this.isNumeric(this.searchText)) {
          this.selectedSearchModel.emailSearchModel.docNumber = parseInt(
            this.searchText.replace(SearchPrefixType.NUMBER, ''),
            10
          );
        }
        break;
      }
    }
  }
  setDocumentSearchModel(autoSelectValue) {
    switch (this.currentSearchCrieteria) {
      case SearchCategoryType.TITLE:
        this.selectedSearchModel.documentSearchModel.searchCriteria = 'title';
        this.selectedSearchModel.documentSearchModel.title = this.searchText.replace(
          SearchPrefixType.TITLE,
          ''
        );
        this.selectedSearchModel.documentSearchModel.searchValue = this.searchText.replace(
          SearchPrefixType.TITLE,
          ''
        );
        break;
      case SearchCategoryType.AUTHOR:
        this.selectedSearchModel.documentSearchModel.searchCriteria =
          'authoroperator';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.documentSearchModel.authorOperator = autoSelectValue.alias;
          this.selectedSearchModel.documentSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.documentSearchModel.authorOperator = this.searchText.replace(
            SearchPrefixType.AUTHOR,
            ''
          );
          this.selectedSearchModel.documentSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.AUTHOR,
            ''
          );
        }
        break;
      case SearchCategoryType.NUMBER:
        if (
          this.isNumeric(this.searchText.replace(SearchPrefixType.NUMBER, ''))
        ) {
          this.selectedSearchModel.documentSearchModel.searchCriteria =
            'number';
          this.selectedSearchModel.documentSearchModel.docNumber = parseInt(
            this.searchText.replace(SearchPrefixType.NUMBER, ''),
            10
          );
          this.selectedSearchModel.documentSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.NUMBER,
            ''
          );
        }
        break;
      case SearchCategoryType.CLIENT:
        this.selectedSearchModel.documentSearchModel.searchCriteria = 'client';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.documentSearchModel.client = autoSelectValue.alias;
          this.selectedSearchModel.documentSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.documentSearchModel.client = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
          this.selectedSearchModel.documentSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.CLIENT,
            ''
          );
        }
        break;
      case SearchCategoryType.MATTER:
        this.selectedSearchModel.documentSearchModel.searchCriteria = 'matter';
        if (this.isShowAutoComplete) {
          this.selectedSearchModel.documentSearchModel.matter = autoSelectValue.alias;
          this.selectedSearchModel.documentSearchModel.searchValue = autoSelectValue.id.toString();
        }
        else {
          this.selectedSearchModel.documentSearchModel.matter = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
          this.selectedSearchModel.documentSearchModel.searchValue = this.searchText.replace(
            SearchPrefixType.MATTER,
            ''
          );
        }
        break;
      default: {
        this.selectedSearchModel.documentSearchModel.searchCriteria = '';
        this.selectedSearchModel.documentSearchModel.searchValue = this.isAlphaNumeric(
          this.searchText
        )
          ? this.searchText
          : '';
        if (
          this.isAlphaNumeric(this.searchText) &&
          !this.isNumeric(this.searchText)
        ) {
          this.selectedSearchModel.documentSearchModel.title = this.searchText.replace(
            SearchPrefixType.TITLE,
            ''
          );
        } else if (this.isNumeric(this.searchText)) {
          this.selectedSearchModel.documentSearchModel.docNumber = parseInt(
            this.searchText.replace(SearchPrefixType.NUMBER, ''),
            10
          );
        }

        break;
      }
    }
  }
  onSearchChange(event) {
    this.isSearchSubmit = false;
    this.isNotSearch = false;
    this.selectedSearchModel.documentSearchModel = new DocumentSearchModel();
    this.selectedSearchModel.emailSearchModel = new EmailSearchModel();
    this.selectedSearchModel.matterSearchModel = new MatterSearchModel();
    if(this.isShowAutoComplete && event.id){
      this.isPopupToBeShown = true;
      this.lookupValueResult = [];
      this.auto.focus();
    }
    if (event === '') {
      this.clearSearchText();
    } else {
      switch (this.selectedSearchModel.selectedSearchType) {
        case SearchTypeEnum.DOCUMENT:
          this.setDocumentSearchModel(event);
          break;
        case SearchTypeEnum.EMAIL:
          this.setEmailSearchModel(event);
          break;
        case SearchTypeEnum.MATTER:
          this.setMatterSearchModel(event);
          break;
        default: {
          break;
        }
      }
    }
  }
  private createLookupRequestBody(searchQuery: string): LookupSearchRequestModel | LibraryInfoModel[] {
    const lookupType = this.currentSearchCrieteria.toLowerCase();
    searchQuery = searchQuery.trim().toLowerCase();
    const baseBody = { lookupType, searchValue: searchQuery, limit: 100 };

    const libraries = this.getLibrarySpecificInformation();
    return { ...baseBody, libraries };
  }

  private getLibrarySpecificInformation(): LibraryInfoModel[] {
    let result: LibraryInfoModel[];
    const libraryList = this.sharedLeftpanelFilterService.getSelectedLibraryList(this.getListTypeOfSelectedValue());
    if (libraryList.length > 0) {
      result = libraryList[0].value.filter(x => x.isSelected)
        .map((library) => ({ libraryGuid : library.libraryGuid }));
    }
    return result;
  }

  getSearchlookup(searchValue) {
    if(searchValue == null || searchValue.trim() == '')
      return false;

    this.selectedSearchModel.documentSearchModel = new DocumentSearchModel();
    this.selectedSearchModel.emailSearchModel = new EmailSearchModel();
    this.selectedSearchModel.matterSearchModel = new MatterSearchModel();
    
    const body = this.createLookupRequestBody(searchValue);

    this.searchService.getLookupData(body).subscribe(
      (result) => {
        if(result.data.length > 0){
          this.lookupValueResult = result.data;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }


  getListTypeOfSelectedValue(): ListTypeEnum {
    let listType = null;
    switch (this.selectedSearchModel.selectedSearchType) {
      case SearchTypeEnum.DOCUMENT:
        listType = ListTypeEnum.DOCUMENT;
        break;
      case SearchTypeEnum.EMAIL:
        listType = ListTypeEnum.EMAIL;
        break;
      case SearchTypeEnum.MATTER:
        listType = ListTypeEnum.MATTER;
        break;
      default: {
        break;
      }
    }
    return listType;
  }
  
  @HostListener('document:click', ['$event'])
  handleOutsideClick(event) {
    if (this.eRef.nativeElement.contains(event.target) === false && event.target.closest('.autocomplete-item') == null) {
      this.isNotSearch =
        !this.isSearchSubmit && this.searchText !== '' ? true : false;
      if (
        !event.target.currentSrc ||
        event.target.currentSrc.indexOf('/cross-icn-search.svg') < 0
      ) {
        this.isPopupToBeShown = false;
      }
      if (this.auto) {
        this.auto.close();
      }
    }
  }
}
